'use client';

import { useState, useEffect } from 'react';

interface Post {
    id: number;
    title: string;
    content: string;
    author: string;
    date: string;
    views: number;
}

const mockPosts: Post[] = [
    { id: 1, title: 'Welcome to VulneraShop', content: 'We are excited to launch our new platform...', author: 'Admin', date: '2024-01-15', views: 1254 },
    { id: 2, title: 'Winter Sale is Here!', content: 'Get up to 50% off on selected items...', author: 'Marketing', date: '2024-01-10', views: 892 },
    { id: 3, title: 'New Product Arrivals', content: 'Check out our latest collection...', author: 'Team', date: '2024-01-05', views: 567 },
];

export default function BlogPage() {
    const [posts, setPosts] = useState<Post[]>(mockPosts);
    const [comment, setComment] = useState('');
    const [comments, setComments] = useState<string[]>([]);

    const submitComment = () => {
        if (comment) {
            setComments([...comments, comment]);
            setComment('');
        }
    };

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-8">Blog</h1>

            <div className="space-y-6">
                {posts.map((post) => (
                    <article key={post.id} className="p-6 rounded-2xl bg-slate-900/50 border border-slate-800">
                        <div className="flex items-center gap-3 text-sm text-slate-400 mb-3">
                            <span>{post.author}</span>
                            <span>•</span>
                            <span>{post.date}</span>
                            <span>•</span>
                            <span>{post.views} views</span>
                        </div>
                        <h2 className="text-xl font-bold mb-3 hover:text-indigo-400 cursor-pointer">{post.title}</h2>
                        <p className="text-slate-400">{post.content}</p>
                        <div className="mt-4 flex gap-4">
                            <button className="text-indigo-400 text-sm hover:underline">Read More</button>
                            <button className="text-slate-400 text-sm hover:underline">Share</button>
                        </div>
                    </article>
                ))}
            </div>

            {/* Comments Section - VULNERABILITY: Stored XSS */}
            <div className="mt-12 p-6 rounded-2xl bg-slate-900/50 border border-slate-800">
                <h3 className="text-xl font-bold mb-6">Comments</h3>

                <div className="flex gap-3 mb-6">
                    <input
                        type="text"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Write a comment..."
                        className="flex-1 px-4 py-3 rounded-xl bg-slate-800 border border-slate-700 focus:border-indigo-500 outline-none"
                    />
                    <button
                        onClick={submitComment}
                        className="px-6 py-3 rounded-xl bg-indigo-600 hover:bg-indigo-500 font-medium transition-all"
                    >
                        Post
                    </button>
                </div>

                <div className="space-y-4">
                    {comments.map((c, i) => (
                        <div key={i} className="p-4 rounded-xl bg-slate-800/50 border border-slate-700">
                            <div className="text-sm text-slate-400 mb-2">Anonymous • Just now</div>
                            {/* VULNERABILITY: Stored XSS - rendering HTML */}
                            <div dangerouslySetInnerHTML={{ __html: c }} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
